import type { AlignmentValue } from '@elfsight/configurator-contracts';

export const getAlignment = (alignment: AlignmentValue) => {
  if (alignment === 'center') {
    return alignment;
  }

  if (alignment === 'left') {
    return 'flex-start';
  }

  return 'flex-end';
};
